import { createRef, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { v4 } from "uuid";
//icons
import boldImg from "../../assets/icons/bold52.png";
import italicImg from "../../assets/icons/italic52.png";
import underlineImg from "../../assets/icons/underline52.png";
import linkImg from "../../assets/icons/link50.png";
import photoImg from "../../assets/icons/photo.svg";
import videoImg from "../../assets/icons/video.svg";
import { logout } from "../../features/userSlice";
import "./AdminPanel.css";

import success from "../../assets/gif/success.gif";
import failed from "../../assets/gif/failed.webp";
import StorageImages from "../../Components/StorageImages/StorageImages";
import ModalWindow from "../../Components/ModalWindow/ModalWindow";
import StorageVideo from "../../Components/StorageVideo/StorageVideo";
import { removeImage, removeLocation } from "../../features/locationSlice";
import Map from "../../Components/Map/Map";
import {
  Editor,
  EditorState,
  RichUtils,
  Modifier,
  CompositeDecorator,
  SelectionState,
  ContentState,
} from "draft-js";
import { stateFromHTML } from "draft-js-import-html";
import { stateToHTML } from "draft-js-export-html";
import "draft-js/dist/Draft.css";
import ImprovisedButton from "./ImrpovisedButton/ImproButton";
import axiosConfig from "../../config/axios";
import { useFetchCategories } from "../../hooks/useCategory";
import { removeLocationImage } from "../../services/locations";
import axios from "axios";
import AdminNavigationLinks from "../../Components/AdminNavigationLinks/AdminNavigationLinks";

//next 3 functions are for handling links
// Function to find link entities
const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

// Component to render links
const Hyperlink = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  const handleClick = (e) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  return (
    <a
      href={url}
      onClick={handleClick}
      style={{ color: "#3b5998", textDecoration: "underline" }}
    >
      {props.children}
    </a>
  );
};

// hyperlink decorator
const createLinkDecorator = () => {
  return new CompositeDecorator([
    {
      strategy: findLinkEntities,
      component: Hyperlink,
    },
  ]);
};

//PROBA URI ERROR!
function convertFromHTML(htmlString) {
  let decodedHtml = "";

  try {
    decodedHtml = decodeURIComponent(
      htmlString.replace(/\\n/g, "\n").replace(/\\"/g, '"'),
    );
  } catch (e) {
    decodedHtml = htmlString; // Fallback to using the raw string
    console.error("Error decoding HTML:", e, htmlString);
  }

  let parsedText = "";

  try {
    if (/<\/?(?!a\b)[a-z][\s\S]*>/i.test(decodedHtml)) {
      parsedText = decodedHtml;
    } else {
      parsedText = decodedHtml
        .split("\n")
        .map((line) => (line.trim() ? `<p>${line}</p>` : "<p>&nbsp;</p>"))
        .join("");
    }

    parsedText = parsedText
      .replace(/&quot;/g, '"')
      .replace(/href="\s*https:\/\/mts.rs/g, 'href="https://mts.rs');

    const contentState = stateFromHTML(parsedText);
    return EditorState.createWithContent(contentState, createLinkDecorator());
  } catch (e) {
    console.error("Error converting HTML to ContentState:", e, parsedText);
    return EditorState.createEmpty(createLinkDecorator());
  }
}

const MAX_SIZE_MB = 20;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

// when build of the project is finished you need to manually fix asset-manifest.json (/adminpanel ---delete) and from js file too before hosting!!!
const AdminPanel = () => {
  const [nameEng, setNameEng] = useState(() => "");
  const [nameLat, setNameLat] = useState(() => "");
  const [nameCir, setNameCir] = useState(() => "");

  const [isAccessible, setIsAccessible] = useState(false); // New state for accessibility

  const [photoInputs, setPhotoInputs] = useState(() => [
    { id: v4(), ref: createRef() },
  ]);
  const [videoInput, setVideoInput] = useState([
    { id: v4(), ref: createRef() },
  ]);

  const [descriptionEng, setDescriptionEng] = useState(() =>
    EditorState.createEmpty(createLinkDecorator()),
  );
  const [descriptionLat, setDescriptionLat] = useState(() =>
    EditorState.createEmpty(createLinkDecorator()),
  );
  const [descriptionCir, setDescriptionCir] = useState(() =>
    EditorState.createEmpty(createLinkDecorator()),
  );
  const editorEngRef = useRef(null);
  const editorLatRef = useRef(null);
  const editorCirRef = useRef(null);

  const [activeStylesEng, setActiveStylesEng] = useState({
    BOLD: false,
    ITALIC: false,
    UNDERLINE: false,
  });

  const [activeStylesLat, setActiveStylesLat] = useState({
    BOLD: false,
    ITALIC: false,
    UNDERLINE: false,
  });

  const [activeStylesCir, setActiveStylesCir] = useState({
    BOLD: false,
    ITALIC: false,
    UNDERLINE: false,
  });

  const [currentEditor, setCurrentEditor] = useState("");

  const [coordinateX, setCoordinateX] = useState(() => "");
  const [coordinateY, setCoordinateY] = useState(() => "");

  const [category, setCategory] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [primaryCategory, setPrimaryCategory] = useState("");
  //-----------------------------------------------all input states
  const [deletingInputStatus, setDeletingInputStatus] = useState(false); //because input automaticaly adds after uploading file and if we dont have this state, we can't delete the last empty input

  const [storagePhotos, setStoragePhotos] = useState([]);
  const [storageVideo, setStorageVideo] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [thumbnailPhoto, setThumbnailPhoto] = useState(null);

  const [deletePhoto, setDeletePhoto] = useState(null);
  const [deleteVideo, setDeleteVideo] = useState(null);

  const [isUploading, setIsUploading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  // List of images we post
  const [imagesToPost, setImagesToPost] = useState([]);
  const [videoToPost, setVideoToPost] = useState();
  const removedPhotoInputIds = useRef(new Set());

  const [error, setError] = useState(false);
  const errorMsg = useRef(null);

  const { data: categories, isLoading: isLoadingCategories } =
    useFetchCategories();

  const currLocation = useSelector((state) => state.location.location); //redux global state

  const dispatch = useDispatch();

  const confirmDeletingPhoto = () => {
    const deletedImage = existingImages[deletePhoto];

    setExistingImages((prevImages) =>
      prevImages.filter((_, idx) => idx !== deletePhoto),
    );

    if (
      thumbnailPhoto?.type === "existing" &&
      thumbnailPhoto.url === deletedImage
    ) {
      const nextImages = existingImages.filter((_, idx) => idx !== deletePhoto);

      setThumbnailPhoto(
        nextImages.length > 0
          ? {
              type: "existing",
              url: nextImages[0],
            }
          : null,
      );
    }

    dispatch(removeImage(deletePhoto));
    setDeletePhoto(null);
  };

  const confirmDeletingVideo = () => {
    // Only remove from local state - actual deletion happens on form submit
    setStorageVideo(null);
    setVideoToPost({ url: "no-video", description: null, order: 0 });
    setDeleteVideo(null);
  };

  const [formInitialized, setFormInitialized] = useState(false);

  useEffect(() => {
    if (currLocation && !formInitialized) {
      setNameEng(currLocation.nameEng);
      setNameLat(currLocation.nameLat);
      setNameCir(currLocation.nameCir);
      setDescriptionEng(convertFromHTML(currLocation.descriptionEng));
      setDescriptionLat(convertFromHTML(currLocation.descriptionLat));
      setDescriptionCir(convertFromHTML(currLocation.descriptionCir));
      setCoordinateX(currLocation.lat);
      setCoordinateY(currLocation.lon);

      if (currLocation.video === "novideo") {
        setStorageVideo(null);
      } else {
        setStorageVideo(currLocation.video);
      }

      const sortedImages = currLocation.images || [];

      setExistingImages(sortedImages);

      if (sortedImages.length > 0) {
        setThumbnailPhoto({
          type: "existing",
          url: sortedImages[0],
        });
      }
      setIsAccessible(!!currLocation.isAccessible); // Set accessibility state

      // check that 'category' is array, if not convert it to one
      const categoryData = Array.isArray(currLocation.category)
        ? currLocation.category
        : [currLocation.category]; // even if there is only one category selected

      const categoryOptions = categoryData.map((cat) => cat);

      setCategory(categoryOptions);
      setPrimaryCategory(currLocation.primaryCategory);

      // Check if 'subcat' is defined before mapping
      const subcatData = currLocation.subcat || [];

      const subcatOptions = subcatData.map((sub) => sub);

      setSubcategory(subcatOptions);
      setFormInitialized(true);
    }
  }, [currLocation, formInitialized]);

  useEffect(() => {
    //adding new input after uploading file but only if deletingInputStatus is true
    const emptyInput = photoInputs.filter((input) => input.img === undefined);

    if (emptyInput.length === 0 && deletingInputStatus) {
      handleAddInput();
    }
  }, [photoInputs]);

  const handleAddInput = () => {
    //adding new photo input
    setDeletingInputStatus(false);
    setPhotoInputs((prevState) => {
      return [...prevState, { id: v4(), ref: createRef() }];
    });
  };

  const handleRemoveInput = (id) => {
    // removing photo input
    if (photoInputs.length === 1) return;

    removedPhotoInputIds.current.add(id);

    setDeletingInputStatus(false);

    setPhotoInputs((prevState) => prevState.filter((el) => el.id !== id));

    setImagesToPost((prevImages) =>
      prevImages.filter((image) => image.inputId !== id),
    );

    if (thumbnailPhoto?.type === "new" && thumbnailPhoto.inputId === id) {
      setThumbnailPhoto(null);
    }
  };

  const handleInputPhotoClicked = (id) => {
    //input is hidden and need to be woked like this
    photoInputs.find((el) => el.id === id).ref.current.click();
  };

  const handleInputVideoClicked = () => {
    //input is hidden and need to be woked like this
    if (storageVideo) return;

    videoInput[0].ref.current.click();
  };

  const handleInputUploaded = async (id) => {
    //making readable photo after uploading to show instantly
    setDeletingInputStatus(true);

    const file = photoInputs.find((el) => el.id === id).ref.current.files[0];

    if (file && file.size <= MAX_SIZE_BYTES) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const uploadedImage = e.target.result;
        setPhotoInputs((prevState) =>
          prevState.map((el) => {
            if (el.id === id) {
              return { ...el, img: uploadedImage };
            } else {
              return el;
            }
          }),
        );
        const req = await handleFileUpload(file);

        if (removedPhotoInputIds.current.has(id)) {
          return;
        }

        setImagesToPost((prev) => [...prev, { ...req, inputId: id }]);
      };
      reader.readAsDataURL(file);
    } else {
      setError(true);
      errorMsg.current = "Image exceeds 20mb";
    }
  };

  const handleFileUpload = async (file) => {
    const formData = new FormData();

    formData.append("file", file);
    formData.append("fileName", file.name);

    try {
      const res = await axiosConfig.post("/images/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // You can access the status code here
        switch (error.response?.status) {
          case 400:
            throw new Error("Bad Request: Please check your input.");
          case 401:
            throw new Error("Unauthorized: Please login.");
          case 404:
            throw new Error("Data not found.");
          case 413:
            throw new Error("Entity Too Large");
          case 500:
            throw new Error("Internal server error, please try again later.");
          default:
            throw new Error("An unexpected error occurred.");
        }
      } else {
        console.error("Error uploading file", error);
        throw new Error("Network error, please check your connection.");
      }
    }
  };

  const handleInputVideoUploaded = async (e) => {
    //making readable video after uploading to show instantly
    const file = e.target.files[0];

    setVideoInput((prevState) => {
      return prevState.map((el) => {
        if (el.ref.current.value) {
          return { ...el, video: URL.createObjectURL(file) };
        } else {
          return el;
        }
      });
    });

    const req = await handleFileUpload(file);

    setVideoToPost({
      url: req.fileId,
      description: null,
      order: 0,
    });
  };

  const handleRemoveVideoInput = (id) => {
    setVideoInput((prevState) => {
      let arr = [{ id: v4(), ref: createRef() }];
      return arr;
    });

    setVideoToPost(null);
  };

  const cleanForm = () => {
    // clean form after uploading is finished
    setNameEng("");
    setNameLat("");
    setNameCir("");
    setPhotoInputs([{ id: v4(), ref: createRef() }]);
    setDescriptionEng(EditorState.createEmpty(createLinkDecorator()));
    setDescriptionLat(EditorState.createEmpty(createLinkDecorator()));
    setDescriptionCir(EditorState.createEmpty(createLinkDecorator()));
    setCoordinateX("");
    setCoordinateY("");
    setCategory([]);
    setSubcategory([]);
    setPrimaryCategory("");
    setVideoInput([{ id: v4(), ref: createRef() }]);
    setStorageVideo(null);
    setIsAccessible(false);
    setFormInitialized(false);
    setImagesToPost([]);
    setExistingImages([]);
    setThumbnailPhoto(null);
    removedPhotoInputIds.current = new Set();
    setVideoToPost(null);
    dispatch(removeLocation());
  };

  const gifTimeout = (time, setStatus) => {
    setTimeout(() => {
      setStatus(false);
    }, time);
  };

  const moveThumbnailToFront = (images, thumbnail) => {
    if (!thumbnail) return images;

    const thumbnailIndex = images.findIndex((image) => {
      if (thumbnail.type === "existing") {
        return image.type === "existing" && image.url === thumbnail.url;
      }

      if (thumbnail.type === "new") {
        return image.type === "new" && image.inputId === thumbnail.inputId;
      }

      return false;
    });

    if (thumbnailIndex <= 0) return images;

    const nextImages = [...images];
    const [selectedImage] = nextImages.splice(thumbnailIndex, 1);

    return [selectedImage, ...nextImages];
  };

  const handleSubmitLocationREST = async (e) => {
    e.preventDefault();

    errorMsg.current = null;
    setError(false);

    // Validation checks
    if (!category.length) {
      errorMsg.current = "Please select at least one category.";
      setError(true);
      return;
    }

    if (category.length > 1 && !primaryCategory) {
      errorMsg.current =
        "Please select a primary category when multiple categories are chosen.";
      setError(true);
      return;
    }

    if (
      coordinateX < -90 ||
      coordinateX > 90 ||
      coordinateY < -90 ||
      coordinateY > 90
    ) {
      return;
    }

    setIsUploading(true);

    const descriptionEngHTML = convertToHTML(descriptionEng);
    const descriptionLatHTML = convertToHTML(descriptionLat);
    const descriptionCirHTML = convertToHTML(descriptionCir);

    const locationId = v4();
    const categoriesToSave = Array.isArray(category) ? category : [category];
    // console.log(category, "THIS IS IN RESTFUL");

    try {
      // Prepare form data for file uploads
      const formData = new FormData();

      // Add video to form data if exists
      const video = videoInput[0].ref.current.files[0];
      if (video) {
        formData.append("video", video);
      }

      const savedCategory = primaryCategory.id
        ? primaryCategory.id
        : category[0].id;

      const savedVideo = videoToPost;

      const existingImageItems = currLocation
        ? existingImages.map((photo) => ({
            type: "existing",
            url: photo,
            description: null,
          }))
        : [];

      const newImageItems = imagesToPost.map((photo) => ({
        type: "new",
        inputId: photo.inputId,
        url: photo.fileId,
        description: null,
      }));

      const orderedImageItems = moveThumbnailToFront(
        [...existingImageItems, ...newImageItems],
        thumbnailPhoto,
      );

      const imagesToSave = orderedImageItems.map((photo, idx) => ({
        url: photo.url,
        description: photo.description,
        order: idx,
      }));

      // Prepare location data
      const locationData = {
        id: currLocation ? currLocation.id : locationId,
        nameEng,
        nameLat,
        nameCir,
        isAccessible: isAccessible,
        descriptionEng: descriptionEngHTML,
        descriptionLat: descriptionLatHTML,
        descriptionCir: descriptionCirHTML,
        mainCategoryId: savedCategory,
        CategoryIds: categoriesToSave.map((cat) => cat.id),
        SubcategoryIds: subcategory.map((sub) => sub.id),
        lat: parseFloat(coordinateX),
        lon: parseFloat(coordinateY),
        images: imagesToSave,
        video: savedVideo,
      };

      // Add location data to form data
      formData.append("locationData", JSON.stringify(locationData));

      // Make API call to create/update location
      const endpoint = currLocation
        ? `/locations/${currLocation.id}`
        : "/locations";

      const method = currLocation ? "PUT" : "POST";

      await axiosConfig(endpoint, {
        method,
        data: locationData,
      });

      setIsSuccess(true);
      gifTimeout(3500, setIsSuccess);
      cleanForm();
    } catch (error) {
      console.error("Error saving location:", error);
      errorMsg.current =
        error.message || "An error occurred while saving the location";
      setError(true);
      setIsFailed(true);
      gifTimeout(3500, setIsFailed);
    } finally {
      setIsUploading(false);
      setStoragePhotos([]);
      setImagesToPost([]);
    }
  };

  const handleLogOut = async (e) => {
    //logout
    e.preventDefault();

    try {
      sessionStorage.removeItem("user");
      dispatch(logout());
      dispatch(removeLocation());
    } catch (error) {
      console.log(error.message);
    }
  };

  function handlePastedText(text, html, editorState, onChange) {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    if (html) {
      const blocksFromHtml = stateFromHTML(html);

      const newContentState = Modifier.replaceWithFragment(
        currentContent,
        selection,
        blocksFromHtml.getBlockMap(),
      );

      const newState = EditorState.push(
        editorState,
        newContentState,
        "insert-fragment",
      );
      onChange(newState);
      return "handled";
    } else if (text) {
      // Handle plain text as before, as there's no formatting to preserve from it
      const blocksFromText = ContentState.createFromText(text).getBlockMap();
      const newContentState = Modifier.replaceWithFragment(
        currentContent,
        selection,
        blocksFromText,
      );
      const newState = EditorState.push(
        editorState,
        newContentState,
        "insert-fragment",
      );
      onChange(newState);
      return "handled";
    }

    // Return 'not-handled' if nothing was processed
    return "not-handled";
  }

  function convertToHTML(editorState) {
    return stateToHTML(editorState.getCurrentContent());
  }

  const promptForLink = (editorState, setEditorState) => {
    const url = window.prompt("Unesite URL za link:");
    if (!url) return;

    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity(
      "LINK",
      "MUTABLE",
      { url },
    );
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const selection = editorState.getSelection();

    const contentStateWithLink = Modifier.applyEntity(
      contentStateWithEntity,
      selection,
      entityKey,
    );

    const linkedEditorState = EditorState.push(
      editorState,
      contentStateWithLink,
      "apply-entity",
    );

    setEditorState(EditorState.forceSelection(linkedEditorState, selection));
  };

  const handleEditorContainerClick = (
    editorRef,
    editorState,
    setEditorState,
  ) => {
    if (editorRef.current) {
      editorRef.current.focus();
      const selection = editorState.getSelection();
      if (!selection.getHasFocus()) {
        const currentContent = editorState.getCurrentContent();
        const lastBlock = currentContent.getBlockMap().last();
        const key = lastBlock.getKey();
        const length = lastBlock.getLength();

        const newSelection = SelectionState.createEmpty(key).merge({
          anchorOffset: length,
          focusOffset: length,
        });

        setEditorState(EditorState.forceSelection(editorState, newSelection));
      }
    }
  };

  const toggleStyle = (style, editor) => {
    let editorState, setEditorState, setActiveStyles, editorRef;

    if (editor === "eng") {
      editorState = descriptionEng;
      setEditorState = setDescriptionEng;
      setActiveStyles = setActiveStylesEng;
      editorRef = editorEngRef;
    } else if (editor === "lat") {
      editorState = descriptionLat;
      setEditorState = setDescriptionLat;
      setActiveStyles = setActiveStylesLat;
      editorRef = editorLatRef;
    } else if (editor === "cir") {
      editorState = descriptionCir;
      setEditorState = setDescriptionCir;
      setActiveStyles = setActiveStylesCir;
      editorRef = editorCirRef;
    }

    // Focus the editor if it is not already focused
    if (document.activeElement !== editorRef.current) {
      editorRef.current.focus();
    }

    const newEditorState = RichUtils.toggleInlineStyle(editorState, style);
    setEditorState(newEditorState);

    setActiveStyles((prevStyles) => ({
      ...prevStyles,
      [style]: !prevStyles[style],
    }));
  };
  //next two function handle the automatic style selection when the text is selected.
  const applyStyles = (
    description,
    setDescription,
    setActiveStyles,
    activeStyles,
  ) => {
    const editorState = description;
    const currentStyle = editorState.getCurrentInlineStyle();
    const selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      const updatedActiveStyles = {};
      let stylesChanged = false;

      Object.keys(activeStyles).forEach((style) => {
        const isCurrentlyActive = currentStyle.has(style);
        updatedActiveStyles[style] = isCurrentlyActive;
        if (isCurrentlyActive !== activeStyles[style]) {
          stylesChanged = true;
        }
      });

      if (stylesChanged) {
        setActiveStyles(updatedActiveStyles);
      }
    } else {
      Object.keys(activeStyles).forEach((style) => {
        const isActive = activeStyles[style];
        const isCurrentlyActive = currentStyle.has(style);
        if (isActive !== isCurrentlyActive) {
          setDescription((prevState) =>
            RichUtils.toggleInlineStyle(prevState, style),
          );
        }
      });
    }
  };

  useEffect(() => {
    const applyCurrentStyles = () => {
      applyStyles(
        descriptionEng,
        setDescriptionEng,
        setActiveStylesEng,
        activeStylesEng,
      );
      applyStyles(
        descriptionLat,
        setDescriptionLat,
        setActiveStylesLat,
        activeStylesLat,
      );
      applyStyles(
        descriptionCir,
        setDescriptionCir,
        setActiveStylesCir,
        activeStylesCir,
      );
    };

    // Throttle updates to prevent excessive re-rendering
    const tout = setTimeout(applyCurrentStyles, 0);
    return () => clearTimeout(tout);
  }, [
    activeStylesEng,
    activeStylesLat,
    activeStylesCir,
    descriptionEng,
    descriptionLat,
    descriptionCir,
  ]);

  const getSubcategoryOptions = () => {
    const options = category.flatMap(
      (cat) =>
        categories.find((option) => option.nameLatin === cat.nameLatin)
          ?.subcategories || [],
    );

    return [...new Set(options.map((option) => JSON.stringify(option)))].map(
      (jsonStr) => JSON.parse(jsonStr),
    );
  };

  const handleCategoryChange = (selectedOptions) => {
    setCategory(selectedOptions || []);

    // update subs based on categories
    updateSubcategories(selectedOptions);

    updatePrimaryCategory(selectedOptions);
  };

  const updateSubcategories = (selectedOptions) => {
    const validSubcategories = selectedOptions
      .flatMap(
        (cat) =>
          categories.find((option) => option.nameLatin === cat.nameLatin)
            ?.subcategories || [],
      )
      .map((option) => option.nameLatin);

    // Filter curren subcat to have only valid ones
    setSubcategory(
      subcategory.filter((sub) => validSubcategories.includes(sub.value)),
    );
  };

  const updatePrimaryCategory = (selectedOptions) => {
    if (selectedOptions.length === 1) {
      setPrimaryCategory(selectedOptions[0].id);
    } else {
      const primaryCategoryOption = selectedOptions.find(
        (option) => option.id === primaryCategory,
      );
      if (!primaryCategoryOption) {
        setPrimaryCategory(
          selectedOptions.length > 0 ? selectedOptions[0].id : "",
        );
      }
    }
  };

  const handlePrimaryCategoryChange = (selectedOption) => {
    setPrimaryCategory(selectedOption);
  };

  const getPrimaryCategoryOptions = () => {
    return category.map((cat) => ({
      nameLatin: cat.nameLatin,
      id: cat.id,
    }));
  };

  const handleSubcategoryChange = (selectedOptions) => {
    setSubcategory(selectedOptions || []);
  };

  return (
    <div className="admin-page">
      <div className="titleContainer">
        {/* <p className="link">
          <Link to="/locations">Pretraga Lokacija</Link>
        </p> */}
        <h1>Admin panel</h1>
        <button className="logout" onClick={handleLogOut}>
          Izloguj se
        </button>
      </div>
      <AdminNavigationLinks />
      <p className="error-msg">{errorMsg.current}</p>
      <form className="form" onSubmit={handleSubmitLocationREST}>
        <div className="multilingual">
          <label>Naziv</label>
          <input
            type="text"
            value={nameEng}
            onChange={(e) => setNameEng(e.target.value)}
            required
            placeholder="...na Engleskom"
          />
          <input
            type="text"
            value={nameLat}
            onChange={(e) => setNameLat(e.target.value)}
            required
            placeholder="...na Latinici"
          />
          <input
            type="text"
            value={nameCir}
            onChange={(e) => setNameCir(e.target.value)}
            required
            placeholder="...на Ћирилици"
          />
        </div>
        {existingImages.length > 0 && (
          <StorageImages
            storagePhotos={existingImages}
            setDeletePhoto={setDeletePhoto}
            setThumbnailPhoto={(url) =>
              setThumbnailPhoto({
                type: "existing",
                url,
              })
            }
            thumbnailPhoto={thumbnailPhoto}
          />
        )}
        <label>Ubaci slike</label>
        <div className="photoInputs-container">
          {photoInputs.map((input, idx) => (
            <div className="singleInput" key={input.id}>
              <input
                onChange={() => handleInputUploaded(input.id)}
                type="file"
                ref={input.ref}
                style={{ display: "none" }}
              />
              <img
                className="thumbnail"
                id={input.id}
                onClick={() => handleInputPhotoClicked(input.id)}
                src={input.img ? input.img : photoImg}
                alt="icon"
              />
              {input.img &&
                (thumbnailPhoto?.type === "new" &&
                thumbnailPhoto.inputId === input.id ? (
                  <span className="thumbnailBadge">Naslovna</span>
                ) : (
                  <button
                    type="button"
                    className="thumbnailBtn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();

                      setThumbnailPhoto({
                        type: "new",
                        inputId: input.id,
                      });
                    }}
                  >
                    Za naslovnu
                  </button>
                ))}
              <span
                className="removeBtn"
                onClick={() => handleRemoveInput(input.id)}
              >
                x
              </span>
            </div>
          ))}
          <span className="btn-addInput" onClick={handleAddInput}>
            Dodaj
          </span>
        </div>
        {!storageVideo ||
          (storageVideo !== "no-video" && (
            <StorageVideo
              storageVideo={storageVideo}
              setDeleteVideo={setDeleteVideo}
            />
          ))}
        <label>Ubaci snimak</label>
        <div className="videoInput-container">
          {videoInput.map((input) => {
            return (
              <div className="singleInput" key={input.id}>
                <input
                  type="file"
                  ref={input.ref}
                  onChange={handleInputVideoUploaded}
                />
                {!input.video && (
                  <img
                    onClick={handleInputVideoClicked}
                    src={videoImg}
                    alt="icon"
                  />
                )}
                {input.video && (
                  <div className="storagePhotoContainer">
                    <video className="video-preview" controls>
                      <source src={input.video} type="video/mp4"></source>
                    </video>
                    <span
                      className="removeBtn"
                      onClick={() => handleRemoveVideoInput(input.id)}
                    >
                      x
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="multilingual">
          <label>Dodaj opis</label>

          {/*ENGLESKI */}
          <div
            className="editor-container"
            onClick={() =>
              handleEditorContainerClick(
                editorEngRef,
                descriptionEng,
                setDescriptionEng,
                setActiveStylesEng,
              )
            }
          >
            <Editor
              ref={editorEngRef}
              editorState={descriptionEng}
              onChange={setDescriptionEng}
              onFocus={() => setCurrentEditor("eng")}
              placeholder="...na Engleskom"
              handlePastedText={(text, html) =>
                handlePastedText(text, html, descriptionEng, setDescriptionEng)
              }
            />
            <div className="editor-controls">
              <ImprovisedButton
                toggleFunction={() => toggleStyle("BOLD", "eng")}
                className={`style-button ${
                  activeStylesEng.BOLD ? "active" : ""
                }`}
              >
                <img src={boldImg} alt="Bold" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("ITALIC", "eng")}
                className={`style-button ${
                  activeStylesEng.ITALIC ? "active" : ""
                }`}
              >
                <img src={italicImg} alt="Italic" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("UNDERLINE", "eng")}
                className={`style-button ${
                  activeStylesEng.UNDERLINE ? "active" : ""
                }`}
              >
                <img src={underlineImg} alt="Underline" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() =>
                  promptForLink(descriptionEng, setDescriptionEng)
                }
                className="style-button link"
              >
                <img src={linkImg} alt="Link" />
              </ImprovisedButton>
            </div>
          </div>
          {/* LATINICA!!!!!!!!! */}
          <div
            className="editor-container"
            onClick={() =>
              handleEditorContainerClick(
                editorLatRef,
                descriptionLat,
                setDescriptionLat,
                setActiveStylesLat,
              )
            }
          >
            <Editor
              ref={editorLatRef}
              editorState={descriptionLat}
              onChange={setDescriptionLat}
              onFocus={() => setCurrentEditor("lat")}
              placeholder="...na Latinici"
              handlePastedText={(text, html) =>
                handlePastedText(text, html, descriptionLat, setDescriptionLat)
              }
            />
            <div className="editor-controls">
              <ImprovisedButton
                toggleFunction={() => toggleStyle("BOLD", "lat")}
                className={`style-button ${
                  activeStylesLat.BOLD ? "active" : ""
                }`}
              >
                <img src={boldImg} alt="Bold" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("ITALIC", "lat")}
                className={`style-button ${
                  activeStylesLat.ITALIC ? "active" : ""
                }`}
              >
                <img src={italicImg} alt="Italic" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("UNDERLINE", "lat")}
                className={`style-button ${
                  activeStylesLat.UNDERLINE ? "active" : ""
                }`}
              >
                <img src={underlineImg} alt="Underline" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() =>
                  promptForLink(descriptionLat, setDescriptionLat)
                }
                className="style-button link"
              >
                <img src={linkImg} alt="Link" />
              </ImprovisedButton>
            </div>
          </div>
          {/* CIRILICA!!!!!!!!! */}
          <div
            className="editor-container"
            onClick={() =>
              handleEditorContainerClick(
                editorCirRef,
                descriptionCir,
                setDescriptionCir,
                setActiveStylesCir,
              )
            }
          >
            <Editor
              ref={editorCirRef}
              editorState={descriptionCir}
              onChange={setDescriptionCir}
              onFocus={() => setCurrentEditor("cir")}
              placeholder="...на Ћирилици"
              handlePastedText={(text, html) =>
                handlePastedText(text, html, descriptionCir, setDescriptionCir)
              }
            />
            <div className="editor-controls">
              <ImprovisedButton
                toggleFunction={() => toggleStyle("BOLD", "cir")}
                className={`style-button ${
                  activeStylesCir.BOLD ? "active" : ""
                }`}
              >
                <img src={boldImg} alt="Bold" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("ITALIC", "cir")}
                className={`style-button ${
                  activeStylesCir.ITALIC ? "active" : ""
                }`}
              >
                <img src={italicImg} alt="Italic" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() => toggleStyle("UNDERLINE", "cir")}
                className={`style-button ${
                  activeStylesCir.UNDERLINE ? "active" : ""
                }`}
              >
                <img src={underlineImg} alt="Underline" />
              </ImprovisedButton>
              <ImprovisedButton
                toggleFunction={() =>
                  promptForLink(descriptionCir, setDescriptionCir)
                }
                className="style-button link"
              >
                <img src={linkImg} alt="Link" />
              </ImprovisedButton>
            </div>
          </div>
        </div>
        <label>Dodaj koordinate</label>
        <div className="cordinates-container">
          <input
            type="number"
            value={coordinateX}
            onChange={(e) => setCoordinateX(e.target.value)}
            placeholder="...latitude"
            required
          />
          <input
            type="number"
            value={coordinateY}
            onChange={(e) => setCoordinateY(e.target.value)}
            placeholder="...longitude"
            required
          />
        </div>
        <Map
          lat={coordinateX}
          lng={coordinateY}
          setLat={setCoordinateX}
          setLng={setCoordinateY}
        />

        <div className="selections-container">
          <div>
            <label>
              Da li je lokalitet pristupačan osobama sa invaliditetom?
            </label>
            <input
              className="checkboxForAccessibility"
              type="checkbox"
              checked={isAccessible}
              onChange={(e) => setIsAccessible(e.target.checked)}
            />
          </div>
          <label>Izaberi kategorije</label>
          <Select
            isMulti
            options={categories}
            value={category}
            onChange={handleCategoryChange}
            getOptionLabel={(option) => option.nameLatin}
            getOptionValue={(option) => option.id}
            classNamePrefix="select"
            className="custom-select-panel"
          />

          {category.length > 0 && (
            <>
              <label>Izaberi potkategorije</label>
              <Select
                isMulti
                options={getSubcategoryOptions()}
                value={subcategory}
                onChange={handleSubcategoryChange}
                getOptionLabel={(option) => option.nameLatin}
                getOptionValue={(option) => option.id}
                classNamePrefix="select"
                className="custom-select-panel"
              />
            </>
          )}

          {category.length > 1 && (
            <>
              <label>Izaberi primarnu kategoriju</label>
              <Select
                options={getPrimaryCategoryOptions()}
                value={primaryCategory}
                onChange={handlePrimaryCategoryChange}
                getOptionLabel={(option) => option.nameLatin}
                getOptionValue={(option) => option.id}
                classNamePrefix="select"
                className="custom-select-panel"
              />
            </>
          )}
        </div>

        {errorMsg.current && <p className="error-msg">{errorMsg.current}</p>}
        <button className="btn-submit" type="submit" disabled={isUploading}>
          Dodaj Lokalitet
        </button>
        {isUploading && (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        )}
        {isSuccess && (
          <div className="spinner-container">
            <img className="successgif" src={success} alt="success" />
          </div>
        )}
        {isFailed && (
          <div className="spinner-container">
            <img className="failedgif" src={failed} alt="failed" />
          </div>
        )}
      </form>
      {typeof deletePhoto === "number" && (
        <ModalWindow
          title="Brisanje fotografije"
          setDeleteData={setDeletePhoto}
          confirmDeletingData={confirmDeletingPhoto}
        />
      )}
      {deleteVideo && (
        <ModalWindow
          title="Brisanje snimka"
          setDeleteData={setDeleteVideo}
          confirmDeletingData={confirmDeletingVideo}
        />
      )}
    </div>
  );
};

export default AdminPanel;
